<template>
  <ui-modal-layout :title="tr('Edit content')" :icon="SparklesIcon">
    <enhanced-textarea
      v-model="insideEntity.content"
      :max-consecutive-newlines="2"
    />

    <template #footer>
      <ui-button :disabled="isSaving" @click="() => saveChanges()">
        <loader-circle-icon v-if="isSaving" class="animate-spin" />
        {{ tr('Save changes') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle, Sparkles } from '@lucide/vue';
import { markRaw } from 'vue';

import ContentGenerationItem from '@/entities/ContentGenerationItem.js';
import CreatorLiteService from '@/services/CreatorLite.js';
import EnhancedTextarea from '@/ui/components/EnhancedTextarea.vue';

export default {
  name: 'CreatorLiteContentEdit',
  components: {
    EnhancedTextarea,
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    entity: {
      type: ContentGenerationItem,
      required: true,
    },
  },
  data: () => ({
    SparklesIcon: markRaw(Sparkles),
    isSaving: false,
    insideEntity: null,
  }),
  created() {
    this.insideEntity = new ContentGenerationItem(this.entity);
  },
  methods: {
    saveChanges() {
      if (this.isSaving) {
        return;
      }

      this.isSaving = true;

      CreatorLiteService.update(this.insideEntity)
        .then(resp => {
          this.entity.updateWith(resp);

          this.$toast.clear();
          this.$toast.success(this.tr('Content changes saved successfully!'));

          this.$emit('close');
          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
